module.exports = __webpack_public_path__ + "static/img/img4.9314f46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carousel/img4.jpg
// module id = paqy
// module chunks = 1